import { Controller } from "@hotwired/stimulus"

// Phase 2.5 Tier 4 — CIP Forecast filter bar.
//
// Auto-submit on any input change so the page reflows without a separate
// "Apply" button. Escalation is captured/displayed as a percent and the
// server divides by 100 — no JS-side conversion needed.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
